import { t } from "i18next";
import * as z from "zod";

import {
  isValidRoutableEmail,
  normalizeEmail,
} from "@/core/utils/func/input-normalization";

/**
 * Schéma du formulaire « mot de passe oublié » (email uniquement).
 * Factory mémoïsée au niveau composant — jamais d'instance exportée.
 */
export const createForgotPasswordSchema = () =>
  z.object({
    email: z
      .string()
      .transform((raw) => {
        const trimmed = raw.trim();
        return trimmed ? normalizeEmail(trimmed) : "";
      })
      .refine((value) => value !== "", { message: t("requiredFieldError") })
      .refine((value) => isValidRoutableEmail(value), {
        message: t("invalidEmailError"),
      }),
  });

export type ForgotPasswordFormValues = z.infer<
  ReturnType<typeof createForgotPasswordSchema>
>;
